import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'dcc-release-name-input',
  templateUrl: './release-name-input.component.html',
  styleUrls: ['./release-name-input.component.scss'],
})
export class ReleaseNameInputComponent implements OnChanges, OnInit, OnDestroy {
  @Output() wordTyped: EventEmitter<string> = new EventEmitter<string>();
  @Input() urlValue: string;
  @ViewChild('input', { static: false }) input: ElementRef;

  inputValue: string;

  private searchSubject = new Subject<string>();
  private subscription: Subscription;

  ngOnInit(): void {
    this.inputValue = this.urlValue;
    this.subscription = this.searchSubject
      .pipe(debounceTime(200)) // Debounce for 200ms
      .subscribe((searchTerm: string) => {
        this.wordTyped.emit(searchTerm); // Emit the debounced value
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['urlValue']) {
      this.inputValue = this.urlValue;
    }
  }

  onInput(): void {
    this.searchSubject.next(this.inputValue);
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
